export default {"src":"/_next/static/media/atm-logo.9c6d505e.svg","height":52,"width":88,"blurWidth":0,"blurHeight":0};